var map = {
	"./AWS.png": "a168",
	"./Azure.png": "9e88",
	"./Azure.png:Zone.Identifier": "0865",
	"./Azure.svg": "8b2a",
	"./Azure.svg:Zone.Identifier": "8149",
	"./SAP.jpg": "cb13",
	"./finance.jpeg": "8fd8",
	"./it.jpeg": "626b",
	"./police.jpeg": "b707",
	"./property.jpeg": "059d",
	"./utilities.jpeg": "3756"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7a0a";